var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectedIcon = function SvgSelectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-action-active, #5835FF)",
    fillRule: "evenodd",
    d: "M0 10c0 5.523 4.477 10 10 10s10-4.477 10-10S15.523 0 10 0 0 4.477 0 10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-action-btn-text, #EBEBEB)",
    d: "M14.818 7.173a.33.33 0 0 1-.005.465l-6.636 6.683-3.003-3.027a.33.33 0 0 1-.001-.465l.664-.67a.33.33 0 0 1 .464-.002l1.884 1.919 5.51-5.583a.323.323 0 0 1 .458.007z"
  })));
};
export default SvgSelectedIcon;